import { BoxProps, LinkBoxProps, StackProps } from '@chakra-ui/react'

export const getContainerStyles = (isSelected: boolean): LinkBoxProps => ({
  display: 'grid',
  gridTemplateColumns: '1fr 220px',
  gridGap: '4',
  borderBottom: '1px solid',
  borderColor: 'gray.200',
  pt: '6',
  pb: '6',
  _last: {
    border: 'none',
  },
  mx: '-24px',
  px: '6',
  backgroundColor: isSelected ? '#f6f6f6' : '#fff',
})

export const actionStackStyles: StackProps = {
  spacing: '1',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
  color: '#444',
}

export const checkIconStyles: BoxProps = {
  width: '16px',
  height: '16px',
  backgroundColor: 'brand.400',
  borderRadius: '100px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  mr: '2',
}
